export default __webpack_public_path__ + "static/media/tacticprovoke.c9190937.png";